export const iconFontAwesomeCommunicationCommentMedical = (
	<i className="fa-solid fa-comment-medical"></i>
);
